<template>
  <div class="audio-form-step">
    <div>STEP</div>
    <div>
      <VaAudioFileInput
        :label="'Audio file'"
        :file-id="fileId"
        @update:file="updateAudioFile"
        :file-name="fileName"></VaAudioFileInput>
      <va-tinymce-input
        class="mb-4 w-full panzoom-ignore"
        :current-content="node.data.aboveContent"
        :editor-height="300"
        title="Above content"
        auto-resize
        @update="content => updateAboveContent(content)" />
      <va-tinymce-input
        class="mb-4 w-full panzoom-ignore"
        :current-content="node.data.belowContent"
        :editor-height="300"
        title="Below content"
        auto-resize
        @update="content => updateBelowContent(content)" />
      <v-btn @click="addItem">Add Button</v-btn>
    </div>
  </div>
</template>

<script>
  import { BUTTON, AUDIO_FILE } from "./constant";
  import VaAudioFileInput from "@/components/custom/VaAudioFileInput";
  import cloneDeep from "lodash/cloneDeep";

  /* eslint-disable */
  export default {
    name: "AudioFormStep",
    components: {
      VaAudioFileInput,
    },
    props: {
      node: {
        type: Object,
        required: true,
      },
      tree: {
        type: Object,
        required: true,
      },
    },
    computed: {
      fileId() {
        return this.node?.data?.audio?.fileID || "";
      },
      fileName() {
        return this.node?.data?.audio?.fileName || "";
      },
    },
    methods: {
      addItem() {
        this.tree.addNode(this.node, cloneDeep(BUTTON));
      },
      updateAboveContent(content) {
        this.node.data.aboveContent = content;
      },
      updateBelowContent(content) {
        this.node.data.belowContent = content;
      },
      updateAudioFile(fileData) {
        if (fileData) {
          this.node.data.audio.fileID = fileData["@id"];
          this.node.data.audio.fileURL = fileData.contentUrl;
          this.node.data.audio.fileName = fileData.fileName;
        } else {
          this.node.data.audio = { ...AUDIO_FILE };
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
